interface IOptions {
  toFixed?: number;
}
export default function addComma(value: number | string, options?: IOptions): string {
  if (options?.toFixed) value = Number(value).toFixed(options.toFixed);
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}